
// wp-block-group

export default class  WpBlockGroup{

    constructor(){


        let groups = document.querySelectorAll('.post-container .wp-block-group, .posts-container .wp-block-group' ) ;

        groups.forEach(function ( block, index ){

            let css_display = getComputedStyle( block ).getPropertyValue('display') ;

            if( 'flex' === String( css_display ) ){
                block.classList.add('wp-block-group--columns-mimic');
            }


        });

    }


}